import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '4fr 4fr 4fr 2fr 3fr 3fr 2fr 1fr',
    gap: 4,
    alignItems: 'center',
    paddingLeft: 12,
    color: 'grey',
    marginTop: 20,
    borderRadius: 12,
    marginBottom: 4,
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : '#f7f7f7',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '8fr 3fr 1fr'
    }
  },
  adminRoot: {
    gridTemplateColumns: '4fr 4fr 4fr 4fr 2fr 3fr 3fr 2fr 1fr'
  },
  correlationIdSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  helpIcon: {
    fontSize: 20,
    marginLeft: 5
  },
  tableSortLabel: {
    color: theme.palette.grey[800]
  }
}))
export default useStyles
